import { useEffect, useState } from 'react';
import { useChatContext } from '../../../../context/ChatContext';
export const useGiphyPreview = (separateGiphyPreview) => {
    const [giphyPreviewMessage, setGiphyPreviewMessage] = useState();
    const { client } = useChatContext('useGiphyPreview');
    useEffect(() => {
        const handleEvent = (event) => {
            const { message, user } = event;
            if (message?.command === 'giphy' && user?.id === client.userID) {
                setGiphyPreviewMessage(undefined);
            }
        };
        if (separateGiphyPreview)
            client.on('message.new', handleEvent);
        return () => client.off('message.new', handleEvent);
    }, [client, separateGiphyPreview]);
    return {
        giphyPreviewMessage,
        setGiphyPreviewMessage: separateGiphyPreview ? setGiphyPreviewMessage : undefined,
    };
};
